export default __webpack_public_path__ + "static/media/genericCardImage.6f39df21.svg";